<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-col
        cols="12"
        sm="12"
        md="8"
      >
        <v-card flat class="mb-4">
          <v-card-title class="subheading font-weight-bold justify-left">
            Thông tin sản phẩm
          </v-card-title>
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="12" md="7">
                <v-list dense>
                  <v-list-item v-if="item.material_area">
                    <v-list-item-content class="font-weight-medium">Vùng nguyên liệu:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.material_area.name}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Cơ sở:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.co_so}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Địa chỉ:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.dia_chi}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Số điện thoại:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.dien_thoai}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content class="font-weight-medium">Quy mô/Sản lượng:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{item.quy_mo}}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="5"
              >
                <v-carousel
                  v-if="item.images && item.images.length > 0"
                  height="250"
                  hide-delimiter-background
                  class="cara"
                >
                  <v-carousel-item
                    eager
                    v-for="img in item.images"
                    :key="img.id"
                    :src="`${apiBaseUrl}/uploads/${img.path}`"
                  />
                </v-carousel>
                <v-img
                  v-else-if="item.logo"
                  height="250"
                  :src="`${apiBaseUrl}/uploads/${item.logo}`"
                />
                <v-img
                  v-else
                  height="250"
                  src="@/assets/dac-san-logo.jpg"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-row>
          <v-col cols="12" v-if="item.mo_ta">
            <v-card flat>
              <v-card-title class="subheading font-weight-bold">
                Mô tả sản phẩm
                <v-spacer/>
                <v-btn icon @click="moreInfoShow=!moreInfoShow">
                  <v-icon>mdi-chevron{{moreInfoShow ? '-up' : '-down'}}</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text 
                v-if="moreInfoShow" 
                v-html="item.mo_ta"
              />
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card flat>
              <v-card-title class="subheading font-weight-bold">
                Giấy chứng nhận
                <v-spacer/>
                <v-btn icon @click="certShow=!certShow">
                  <v-icon>mdi-chevron{{certShow ? '-up' : '-down'}}</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text v-if="certShow">
                <v-row v-if="item.cert_images && item.cert_images.length > 0">
                  <v-col
                    cols="6"
                    sm="4"
                    v-for="(gcnimage, index) in item.cert_images"
                    :key="`gcnimage${index}`"
                  >
                    <v-img
                      @click="fileView(gcnimage.path)"
                      :src="`${apiBaseUrl}/uploads/${gcnimage.path}`"
                      style="cursor: pointer;"
                    />
                  </v-col>
                </v-row>
                <span v-else>
                  Không tìm thấy dữ liệu
                </span>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-spacer/>
      <v-col
        cols="12"
        sm="12"
        md="4"
      >
        <v-card flat class="text-center">
          <v-card-text>
            <span class="text-h6 font-weight-bold">
              Các chuỗi khác
            </span> 
          </v-card-text>
        </v-card>
        <v-card 
          v-if="relatedItems.length == 0"
          flat 
          class="text-center"
        >
          <v-card-text>
            <span>
              Không tìm thấy sản phẩm phù hợp
            </span>
          </v-card-text>
        </v-card>
        <v-card flat v-for="(related_item, index) in relatedItems"
          :to="{ name: 'ChainProductTrace', params: { id: related_item.id }}"
          :key="`related_item${index}`"
          class="px-6"
        >
          <div class="d-flex flex-no-wrap">
            <v-avatar
              class="ma-3 rounded-lg"
              size="100"
              tile
            >
              <v-img 
                v-if="related_item.logo"
                :src="`${apiBaseUrl}/uploads/${related_item.logo}`"
                contain
              />
            </v-avatar>
            <div>
              <v-card-title class="text-h6">
                <div class="product-name">
                  {{related_item.san_pham}}
                </div>
              </v-card-title>
              <v-card-subtitle>
                <p><v-icon small>mdi-map-marker</v-icon>
                  {{related_item.dia_chi}}</p>
              </v-card-subtitle>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogQrZoom"
      persistent
      max-width="290"
    >
      <v-card>
        <v-app-bar
          dark
          color="primary"
        >
          <v-icon>
            mdi-tablet-cellphone
          </v-icon>
          <v-spacer/>
          <v-toolbar-title>Mã truy xuất</v-toolbar-title>
          <v-spacer/>
          <v-btn
            icon
            @click="closeZoomQrCode()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                v-if="qrItem"
                align="center"
                justify="center"
              >
                <qrcode-vue 
                  :value="GenerateURL(qrItem)" 
                  :size="170" 
                  level="H"
                />
                {{qrItem ? qrItem.ma_truy_xuat: null}}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import QrcodeVue from 'qrcode.vue';
  import { mapState, mapActions } from 'vuex';
  import {
    Hooper,
    Slide,
    Navigation as HooperNavigation
  } from 'hooper';
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  import SystemSevice from '@/services/System';
  export default {
    components: {
      QrcodeVue,
      Hooper,
      Slide,
      HooperNavigation,
      BaseBreadcrumbs
    },
    data: () => ({
      crumbs: [],
      model: 0,
      tabs: 0,
      item: {
        business: {
          cert_images: {

          }
        }
      },
      relatedItems: [],
      dialogQrZoom: false,
      qrItem: null,
      hooperSettings: {
        infiniteScroll: true,
        centerMode: true,
        wheelControl: false,
        breakpoints: {
          2400: {
            itemsToShow: 8
          },
          1800: {
            itemsToShow: 6
          },
          1500: {
            itemsToShow: 5
          },
          1100: {
            itemsToShow: 4
          },
          768: {
            itemsToShow: 3
          },
          576: {
            itemsToShow: 2
          },
          0: {
            itemsToShow: 2
          }
        }
      },
      moreInfoShow: true,
      certShow: true,
    }),
    computed: {
      ...mapState([
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    watch: {
      "$route.params.id": function() {
        this.initialize();
        this.getRelatedItems();
      }
    },
    mounted () {
      this.getRelatedItems();
      this.initialize();
      SystemSevice.setSiteViewLocal({
        name: `ChainProductTrace@${this.$route.params.id}`,
      });
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      initialize(){
        const app = this;
        app.getLoader(true);
        axios.get(`api/v1/public/product-chains/${app.$route.params.id}`)
          .then(response => {
            app.item = response.data;
            app.crumbs = [
              {
                text: 'Sản phẩm chuỗi',
                disabled: false,
                href: '/products/chain',
              },
              {
                text: app.item.san_pham,
                disabled: true
              }
            ];
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      getRelatedItems(){
        axios.get(`api/v1/public/product-chains-related/${this.$route.params.id}`)
          .then(response => {
            this.relatedItems = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      GenerateURL(){
        let path = this.$router.resolve({
          name: 'ProductTrace', 
          params: {
            id: this.item.id
          }
        });
        return `${window.location.origin}/${path.href}`;
      },
      addToCart(item) {
        this.$store.commit('addToCart', item);
        this.$router.push({ name: 'Cart' });
      },
      zoomQrCode(item){
        this.dialogQrZoom=true;
        this.qrItem=item;
      },
      closeZoomQrCode(){
        this.dialogQrZoom=false;
      },
      fileView(file){
        window.open(
          `${this.config.beUrl}/uploads/${file}`,
          '_blank'
        );
      }
    }
  }
</script>
<style>
  .v-card--flat {
    box-shadow: 0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12) !important;
  }
  .cara .v-image__image--cover {
    background-size: contain;
  }
  .basil {
    background-color: #FFFBE6 !important;
  }
  .basil--text {
    color: #356859 !important;
  }
  .product-name:first-letter {
    text-transform: uppercase;
  }
</style>